import { VpSkeleton } from '@vtmn-play/react'

type WidgetLoadingProps = {
  skeletonCount?: number
  className?: string
  dataTestId?: string
  skeletonProps?: object
}

const WidgetLoading = ({
  skeletonCount = 2,
  className = 'mg-widget-loading',
  dataTestId,
  skeletonProps
}: WidgetLoadingProps) => (
  <div data-test-id={dataTestId} className={className}>
    {Array.from({ length: skeletonCount }, (_, index) => (
      <VpSkeleton key={index} {...skeletonProps} />
    ))}
  </div>
)

export default WidgetLoading
